import React from 'react';
import { LogOut, User } from 'lucide-react';

export const Header = ({ 
  title, 
  subtitle, 
  userProfile, 
  onLogout, 
  actions 
}) => {
  return (
    <header className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-4 py-4 sm:py-6 lg:flex-row lg:items-center lg:justify-between">
          {/* Left side - Title and subtitle */}
          <div className="min-w-0 flex-1">
            <h1 className="text-2xl font-bold text-gray-900 break-words">{title}</h1>
            {subtitle && (
              <p className="mt-1 text-sm text-gray-600 break-words">{subtitle}</p>
            )}
          </div>

          {/* Center - Actions */}
          {actions && (
            <div className="w-full lg:mx-4 lg:w-auto lg:flex-shrink-0">
              {actions}
            </div>
          )}

          {/* Right side - User profile and logout */}
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between lg:justify-end">
            {/* User Profile */}
            {userProfile && (
              <div className="flex min-w-0 items-center space-x-3">
                <div className="flex min-w-0 items-center space-x-2">
                  <div className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center">
                    <User className="h-5 w-5 text-gray-600" />
                  </div>
                  <div className="min-w-0 text-sm">
                    <p className="truncate font-medium text-gray-900">
                      {userProfile?.full_name || 'Utente'}
                    </p>
                    <p className="truncate text-gray-500">
                      {userProfile?.role === 'admin' ? 'Amministratore' : 
                       userProfile?.role === 'order_user'? 'Venditore' : 'Utente'}
                    </p>
                  </div>
                </div>
                
                {/* Role Badge */}
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                  userProfile?.role === 'admin' ?'bg-yellow-100 text-yellow-800' :'bg-blue-100 text-blue-800'
                }`}>
                  {userProfile?.role === 'admin' ? 'Admin' : 'User'}
                </span>
              </div>
            )}

            {/* Logout Button */}
            {onLogout && (
              <button
                onClick={onLogout}
                className="inline-flex w-full items-center justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 sm:w-auto"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Esci
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
